import { useInitializeTranslations } from '@telialt/common-cms/src/useTranslations';

const text = {
    title: 'footer.app_promotion.title',
    description: 'footer.app_promotion.description',
    qrCodeTitle: 'footer.app_promotion.qr.code.title',
    appStoreUrl: 'footer.app_promotion.app.store.url',
    appStoreTitle: 'footer.app_promotion.app.store.title',
    googlePlayUrl: 'footer.app_promotion.google.play.url',
    googlePlayTitle: 'footer.app_promotion.google.play.title',
};

type FooterAppPromotionText = typeof text;

export const useFooterAppPromotionText = () => {
    const { t, hasMessage } = useInitializeTranslations();

    if (t && Object.values(text).every(hasMessage)) {
        return Object.fromEntries(Object.entries(text).map(([name, key]) => [name, t[key]])) as FooterAppPromotionText;
    }

    return null;
};
